
import React from 'react';
import { Input } from '@/components/ui/input';
import { ResellerPlanDetails } from '@/hooks/license/resellerPlans/types';

interface PlanLimitsProps {
  plan: ResellerPlanDetails;
  onUpdatePlan: (field: keyof ResellerPlanDetails, value: any) => void;
}

const PlanLimits: React.FC<PlanLimitsProps> = ({ plan, onUpdatePlan }) => {
  const handleNumberInput = (field: keyof ResellerPlanDetails, value: string) => {
    const numValue = parseInt(value);
    onUpdatePlan(field, isNaN(numValue) ? 0 : numValue);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-medium">Max Instances</label>
        <Input 
          type="number" 
          value={plan.maxInstances} 
          onChange={(e) => handleNumberInput('maxInstances', e.target.value)}
        />
        <p className="text-xs text-gray-500 mt-1">
          Maximum number of instances this reseller can create
        </p>
      </div>
      
      <div>
        <label className="text-sm font-medium">Max Managers</label>
        <Input 
          type="number" 
          value={plan.maxManagers} 
          onChange={(e) => handleNumberInput('maxManagers', e.target.value)}
        />
        <p className="text-xs text-gray-500 mt-1">
          Maximum number of manager accounts
        </p>
      </div>
      
      <div>
        <label className="text-sm font-medium">Max Admins</label>
        <Input 
          type="number" 
          value={plan.maxAdmins} 
          onChange={(e) => handleNumberInput('maxAdmins', e.target.value)}
        />
        <p className="text-xs text-gray-500 mt-1">
          Maximum number of admin accounts across all instances
        </p>
      </div>
      
      <div>
        <label className="text-sm font-medium">Max Users</label>
        <Input 
          type="number" 
          value={plan.maxUsers} 
          onChange={(e) => handleNumberInput('maxUsers', e.target.value)}
        />
        <p className="text-xs text-gray-500 mt-1">
          Maximum number of end users across all instances
        </p>
      </div>
    </div>
  );
};

export default PlanLimits;
